import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import '@/shared/i18n/i18n'; // i18n must be imported before App
import '@/index.css';
import '@/smarthome-theme.css';
import App from '@/App';
import { reportWebVitals } from '@/shared/lib';

const rootElement = document.getElementById('root')!;

// Check if the app is being hydrated (prerendered by react-snap)
if (rootElement.hasChildNodes()) {
  // Hydrate the pre-rendered HTML
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </React.StrictMode>
  );
} else {
  // Normal client-side render
  const root = ReactDOM.createRoot(rootElement as HTMLElement);
  root.render(
    <React.StrictMode>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </React.StrictMode>
  );
}

reportWebVitals();
